const HighlightText = ({children}: React.PropsWithChildren<{}>) => {
  return (
  <span className="bg-mh-purple font-semibold py-1">
    {children}
  </span>
  )
}

export default HighlightText
